export default __webpack_public_path__ + "static/media/RO.b8106fb5.svg";